import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectAccount } from "../../slices/userSlice";
import TermsDialog from "./TermsDialogForm";

const TermsDialogWrapper = () => {
    const account = useSelector(selectAccount);
    const [termsDialogOpen, setTermsDialogOpen] = useState(true);

    if (account.hasAgreedToLatestTC) {
        return null;
    }

    return <TermsDialog handleClose={() => setTermsDialogOpen(false)} termsDialogOpen={termsDialogOpen} />;
};

export default TermsDialogWrapper;
